import { render, staticRenderFns } from "./printDialog.vue?vue&type=template&id=2987b2f6&scoped=true"
import script from "./printDialog.vue?vue&type=script&lang=js"
export * from "./printDialog.vue?vue&type=script&lang=js"
import style0 from "./printDialog.vue?vue&type=style&index=0&id=2987b2f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2987b2f6",
  null
  
)

export default component.exports